import classNames from 'classnames';
import React from 'react';

type Props = {
    class?: string;
    className?: string;
    style?: React.CSSProperties;
};
export function BreathingCircle({ style, className, ...props }: Props) {
    return (
        <div
            {...props}
            className={classNames(
                props.class,
                className,
                'breathing-circle bg-vibrant-blue-10p bg-vibrant-blue-30p',
            )}
            style={
                {
                    ...style,
                    '--small-color': 'var(--vibrant-blue-10p)',
                    '--large-color': 'var(--vibrant-blue-30p)',
                } as any
            }
        />
    );
}
